<template>
  <div class="page-block">
    <div
      v-if="!readonly"
      class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        アカウント情報 - 確認
      </h3>
    </div>
    <div class="page-block__inner">
      <release-step-area
        v-if="!hideSteps"
        :index="4" />
      <alert-view
        :errors="errors" />
      <div class="form-wrap form-wrap--profile u-no-margin-top">
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">アカウント管理者氏名
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.contact_name }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label class="control-label">
              生年月日
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item">
            {{ data.dob }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">郵便番号
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ formatPostalCode() }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">都道府県
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.prefecture }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">市区町村/番地
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.address1 }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">建物名
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.address2 }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">銀行名
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.bank_name }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">支店名
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.bank_branch_name }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">口座種別
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ backAccountTypeText.text }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">口座番号
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.bank_account_code }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">口座名義
              <span class="req">＊</span>
            </label>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ data.bank_account_name }}
          </div>
        </div>
      </div>
      <div
        class="c-btn-wrap">
        <a
          class="c-btn"
          href="#"
          @click.prevent="onNextClicked">
          <span>{{ feature.includes('split')
            ? 'スプリット情報の確認へ'
            : status === 2 ? '配信審査を依頼する' : '個人情報の確認へ' }}</span>
          <span class="c-btn__icon-arrow"></span>
        </a>
        <a
          class="c-btn c-btn--back c-btn--back-left"
          href="#"
          @click.prevent="onBackClicked">
          <span>編集画面に戻る</span>
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import ReleaseStepArea from '../Release/StepArea'
import AlertView from './AlertView'

export default {
  name: 'ConfirmAccountInformation',
  components: {
    AlertView,
    ReleaseStepArea,
  },
  props: {
    companyId: {
      type: [String, Number],
      required: true,
    },
    hideSteps: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      readonly: false,
      type: 'single',
      data: {
        bank_account_code: '',
      },
      bankAccountTypes: [
        {
          id: 0,
          text: '普通預金',
        },
        {
          id: 1,
          text: '当座預金',
        },
      ],
      backAccountTypeText: '',
      feature: 'release',
      errors: {},
      status: '',
    }
  },
  mounted() {
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (release) {
      this.status = release.status
    }
    this.data = JSON.parse(window.sessionStorage.getItem('account_information'))
    this.data.dob = moment(this.data.dob).format('YYYY-MM-DD')
    this.feature = this.data?.feature || 'release'
    this.backAccountTypeText = this.bankAccountTypes
      .find(item => item.id === parseInt(this.data.bank_account_type, 10))
  },
  methods: {
    onBackClicked() {
      this.$emit('show', 'user-data-input')
    },
    formatPostalCode() {
      if (this.data.postal_code) {
        return `${this.data.postal_code.slice(0, 3)}-${this.data.postal_code.slice(3)}`
      }
      return ''
    },
    async onNextClicked() {
      try {
        const response = await window.axios.put(`/api/client/companies/${this.companyId}`, this.data)
        if (response.status === 200) {
          switch (this.feature) {
            case 'split-detail': {
              const { invitationCode } = JSON.parse(window.sessionStorage.getItem('split'))
              await this.$router
                .push({
                  path: '/client/revenue-share/invitation-code',
                  query: { invitation_code: invitationCode },
                })
              break
            }
            case 'split-invitation': {
              const { productId, revenueShareId } = JSON.parse(window.sessionStorage.getItem('split'))
              await this.$router
                .push({ path: `/client/revenue-share/confirm-revenue-share/${productId}/${revenueShareId}` })
              break
            }
            case 'copyright-split-invitation': {
              const { splitId } = JSON.parse(window.sessionStorage.getItem('copyright-split'))
              await this.$router
                .push({ path: `/client/copyright/confirm-copyright-split/${splitId}` })
              break
            }
            default: {
              // 追加ストア申請時、SMS認証を外すし、完了画面に遷移する
              if (this.status === 2) {
                this.$emit('onCompleteRelease')
              } else {
                this.$emit('show', 'mobile-input')
              }
            }
          }
        } else {
          this.$emit('show', 'user-data-input')
        }
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        window.scrollTo(0, 0)
      }
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 895px) {
  .page-block__heading {
    padding: 1.3333333333vw 2.6666666667vw;
    min-height: 13.3333333333vw;
  }
}
</style>
